import { SearchState } from '@/domain/search/types'
import { isNonEmptyArray } from '@/utils/checks'
import {
  BROWSE_BOOST_PER_TERM,
  MIN_BROWSE_BOOST,
  MATCHED_BROWSE_TREATS_BOOST_CAP,
  FACETS_TO_BOOST
} from './constants'

export const boostMultiSearchCenter = (
  new_specializations: string[],
  searchState: SearchState['refinementList']
): number => {
  if (!isNonEmptyArray(new_specializations) || !searchState) {
    return 0
  }

  const matchedItems = Object.keys(searchState).reduce((acc, key) => {
    if (FACETS_TO_BOOST.includes(key) && isNonEmptyArray(searchState[key])) {
      return { ...acc, [key]: searchState[key] }
    }

    return acc
  }, {})
  const matchedBoostValues = Object.values(matchedItems)
    .flat()
    .filter((term: string) => new_specializations.includes(term)).length

  const hasMatchingTerms = Object.values(searchState)
    .flat()
    .some((term: string) => {
      return new_specializations.includes(term)
    })

  if (matchedBoostValues) {
    return Math.min(
      matchedBoostValues * BROWSE_BOOST_PER_TERM + MIN_BROWSE_BOOST,
      MATCHED_BROWSE_TREATS_BOOST_CAP
    )
  }

  if (hasMatchingTerms) {
    return MIN_BROWSE_BOOST
  }

  return 0
}
